import React from 'react';
import { isEmpty } from 'lodash';
import { FlexContainer } from '../../layouts/Wrapper/Base.components';
import IconContainer from '../IconContainer';
import Icon from '../Icon';
import Text from '../Text';
import Button from '../Button';
import { string, bool, any, object, number } from 'prop-types';
import { DARK_CHARCOAL, GREEN_DARK } from '../../../utils/colors';

const NotFound = ({
    iconBackgroundColor,
    icon,
    iconColor,
    iconSize,
    fontSize,
    firstTextLine,
    secondTextLine,
    hasGoBack,
    childButton,
    style,
    iconContainerSize,
    centered,
    backgroundColor,
    firstTextSize,
    secondTextSize,
    border
}) => (
    <FlexContainer
        justify='center'
        align='center'
        grow={1}
        style={{ backgroundColor, ...style }}
        textAlign='center'
        direction='column'
        padding={20}
    >
        <IconContainer color={iconBackgroundColor} size={iconContainerSize} border={border}>
            <Icon name={icon} size={iconSize} color={iconColor} />
        </IconContainer>
        <div style={{ margin: '20px 0', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Text
                size={firstTextSize || fontSize}
                text={firstTextLine}
                centered={centered}
                semibold
                color={isEmpty(secondTextLine) ? DARK_CHARCOAL : GREEN_DARK}
            />
            <Text size={secondTextSize || fontSize} text={secondTextLine} centered={centered} />
        </div>
        { hasGoBack && <Button text='Volver' width='auto' onClick={() => window.history.back()} /> }
        { childButton }
    </FlexContainer>
);

NotFound.propTypes = {
    iconBackgroundColor: string,
    icon: string,
    iconColor: string,
    iconSize: number,
    fontSize: number,
    firstTextLine: string,
    secondTextLine: string,
    hasGoBack: bool,
    childButton: any,
    style: object,
    iconContainerSize: string,
    centered: bool,
    backgroundColor: string,
    firstTextSize: number,
    secondTextSize: number,
    border: string
};

NotFound.defaultProps = {
    iconBackgroundColor: '#f38630',
    icon: 'caution',
    iconColor: '#FFFFFF',
    iconSize: 43,
    fontSize: 17,
    firstTextLine: '',
    secondTextLine: '',
    hasGoBack: false,
    childButton: null,
    style: {},
    centered: false,
    backgroundColor: '#FFFFFF'
};

export default NotFound;
